import React, { Component } from "react";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import {
  Form,
  Input,
  Row,
  Col,
  Button,
  Card,
  message,
  TimePicker,
  Select,
} from "antd";
import AppConfigs from "../../Config/AppConfig";
import { update, getDetails } from "../../api/Apis";
// import { Storage } from 'aws-amplify';
import LocationAutocomplete from "../../Components/Autocomplete";
import moment from "moment";
import { noWhitespaceRule, notValidPhoneNumberRule } from "../../utils/Utils";
import ErrorPage from "../ErrorPage";

const format = "hh:mm A";
const { Option } = Select;
class AddLocation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      confirmDirty: false,
      fileList: [],
      startValue: "",
      endValue: "",
      materialsLoaded: [],
      measurementType: [],
      loadingCodes: [],
      selectedLocation: {},
      editMode: false,
      previousAddress: "",
      actionType: "new",
      recordId: "",
      userDetails: JSON.parse(localStorage.getItem("userDetails")),
    };
  }
  setStartValue = (value) => {
    this.setState({
      startValue: value,
    });
    // this.changeFieldValue(value,index,id);
  };
  setEndValue = (value) => {
    if (!value) {
      if (
        this.props.form.getFieldValue("startTime") >
        this.props.form.getFieldValue("endTime")
      ) {
        message.error("Please select valid time");
        this.props.form.setFieldsValue({
          endTime: null,
        });
        return;
      } else {
        this.props.form.setFieldsValue({
          endTime: this.props.form.getFieldValue("endTime"),
        });
      }
      //   this.changeFieldValue(value,index,id);
    }
  };

  componentDidMount = () => {
    let search = new URLSearchParams(this.props.location.search);
    let actionType = search.get("actionType");
    this.setState({
      actionType,
    });
    if (actionType === "edit") {
      let orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
      getDetails(
        AppConfigs["entityNames"]["organizations"],
        orgDetails["id"]
      ).then(async (result) => {
        if (result.success) {
          localStorage.setItem("orgDetails", JSON.stringify(result.data));
          let id = search.get("id");
          this.setFormFieldValues(id);
        } else {
          console.log(result.errors);
          this.setState({
            dataLoadingStatus: false,
          });
        }
      });
    }
  };

  setFormFieldValues = (id) => {
    let orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
    let selectedLocation = orgDetails["yardLocations"].filter(
      (loc) => loc.id === id
    );
    if (selectedLocation.length > 0) {
      this.setState({
        recordId: id,
        selectedLocation: selectedLocation[0],
        latLng: selectedLocation[0]["latLng"],
        previousAddress: selectedLocation[0]["address"],
        editMode: true,
      });
      this.props.form.setFieldsValue({
        locationName: selectedLocation[0]["locationName"],
        address: selectedLocation[0]["address"],
        startTime:
          "loadingTimes" in selectedLocation[0]
            ? moment(
                selectedLocation[0]["loadingTimes"].split(" - ")[0],
                "hh:mm A"
              )
            : null,
        endTime:
          "loadingTimes" in selectedLocation[0]
            ? moment(
                selectedLocation[0]["loadingTimes"].split(" - ")[1],
                "hh:mm A"
              )
            : null,
        materialsLoaded:
          "materialsLoaded" in selectedLocation[0]
            ? selectedLocation[0]["materialsLoaded"]
            : [],
        measurementType:
          "loadTypes" in selectedLocation[0]
            ? selectedLocation[0]["loadTypes"]
            : [],
        loadingCodes:
          "loadingCodes" in selectedLocation[0]
            ? selectedLocation[0]["loadingCodes"]
            : [],
        firstName:
          "firstName" in selectedLocation[0]
            ? selectedLocation[0]["firstName"]
            : "",
        lastName:
          "lastName" in selectedLocation[0]
            ? selectedLocation[0]["lastName"]
            : "",
        email:
          "email" in selectedLocation[0] ? selectedLocation[0]["email"] : "",
        phone:
          "phone" in selectedLocation[0] ? selectedLocation[0]["phone"] : "",
      });
    } else {
      this.props.history.push("/app/settings");
    }
    console.log(selectedLocation);
  };
  hasErrors = (fieldsError) =>
    Object.keys(fieldsError).some((field) => fieldsError[field]);
  handleSubmit = (e) => {
    e.preventDefault();
    let orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
    let yardLocations = [];
    if (orgDetails["yardLocations"]) {
      yardLocations = orgDetails["yardLocations"];
    }
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.setState({
          loading: true,
        });
        console.log("no errors");
        // let imageKeys = [];
        let data = {
          id:
            this.state.actionType === "edit"
              ? this.state.recordId
              : moment().valueOf().toString(),
          locationName: values["locationName"],
          address: values["address"],
          latLng: this.state.latLng,
          loadingTimes:
            moment(values["startTime"]).format("hh:mm A") +
            " - " +
            moment(values["endTime"]).format("hh:mm A"),
          materialsLoaded: values["materialsLoaded"],
          loadTypes: values["measurementType"],
          loadingCodes: values["loadingCodes"],
          firstName: values["firstName"],
          lastName: values["lastName"],
          email: values["email"] ? values["email"] : null,
          phone: values["phone"],
        };
        // this.state.fileList.map((async file => {
        //     let fileName = values["locationName"].replace(/\s+/g, '') + "_" + file["name"];
        //     await Storage.put(fileName, file, {
        //         contentType: file.type,
        //     }).then(result => {
        //         imageKeys.push(result.key)
        //         if (this.state.fileList.length === imageKeys.length) {
        //             data["mapImage"] = imageKeys;
        //             if(this.state.actionType === "new") {
        //                 yardLocations.push(data);
        //             } else {
        //                 yardLocations = yardLocations.filter((loc) => loc.id !== this.state.recordId);
        //                 yardLocations.push(data);
        //             }
        //             let locationData = {
        //                 "entityData": {
        //                     "yardLocations": yardLocations
        //                 }
        //             }
        //             this.updateRecord(orgDetails["id"], locationData);
        //         }
        //     })
        //     .catch(err => console.log(err));
        // }));
        // if(this.state.fileList.length === 0 && this.state.actionType === "edit") {
        data["mapImage"] = null; //this.state.selectedLocation["mapImage"];
        let newYardLocations = [];
        if (this.state.actionType === "new") {
          newYardLocations = yardLocations;
          newYardLocations.push(data);
        } else {
          newYardLocations = yardLocations.filter(
            (loc) => loc.id !== this.state.recordId
          );
          newYardLocations.push(data);
        }
        let locationData = {
          entityData: {
            yardLocations: newYardLocations,
          },
        };
        // console.log(locationData);
        this.updateRecord(orgDetails["id"], locationData);
        // }
      }
    });
  };

  updateRecord = (id, locationData) => {
    update(AppConfigs["entityNames"]["organizations"], id, locationData).then(
      (result) => {
        if (result.success) {
          localStorage.setItem(
            "orgDetails",
            JSON.stringify(result["data"]["data"])
          );
          this.props.history.push("/app/settings");
        } else {
          console.log(result.errors);
        }
      }
    );
  };

  getAddress = (address, latLng) => {
    this.props.form.setFieldsValue({
      address: address,
    });
    this.setState({
      latLng: latLng,
    });
  };
  handleConfirmBlur = (e) => {
    const { value } = e.target;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };
  handleChange = (value) => {
    console.log(`selected ${value}`);
  };
  setStartValue = (value, id) => {
    this.setState({
      startValue: value,
    });
  };
  setEndValue = (value, id) => {
    if (!value) {
      if (
        this.props.form.getFieldValue("startTime") >
        this.props.form.getFieldValue("endTime")
      ) {
        message.error("Please select valid time");
        this.props.form.setFieldsValue({
          [id]: null,
        });
        return;
      } else {
        this.props.form.setFieldsValue({
          [id]: this.props.form.getFieldValue("endTime"),
        });
      }
    }
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    // const props = {
    //     name: 'file',
    //     multiple: true,
    //     action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
    //     onChange(info) {
    //         const { status } = info.file;
    //         if (status !== 'uploading') {
    //             // this.fileList = info.fileList;
    //             // // this.setState({
    //             // //     fileList:info.fileList
    //             // // })
    //             console.log(info.file, info.fileList);
    //         }
    //         if (status === 'done') {
    //             message.success(`${info.file.name} file uploaded successfully.`);
    //         } else if (status === 'error') {
    //             message.error(`${info.file.name} file upload failed.`);
    //         }
    //     },
    //     onRemove: file => {
    //         this.setState(state => {
    //             let index = state.fileList.indexOf(file);
    //             const newFileList = state.fileList.slice();
    //             newFileList.splice(index, 1);
    //             return {
    //                 fileList: newFileList,
    //             };
    //         });
    //     },
    //     beforeUpload: file => {
    //         this.setState(state => ({
    //             fileList: [...state.fileList, file],
    //         }));
    //         return false;
    //     },
    // };
    // const noWhitespaceRule = {
    //   validator(_, value) {
    //     if (value && value.trim()!=="") {
    //       return Promise.resolve();
    //     }
    //     return Promise.reject("Only whitespace not allow.");
    //   },
    // };

    if (
      this.state.userDetails.userProfile !== "A" &&
      this.state.userDetails.userProfile !== "M"
    ) {
      return <ErrorPage />;
    }
    return (
      <div
        style={{
          position: "absolute",
          top: "143px",
          paddingLeft: "36%",
          paddingRight: "25%",
        }}
        className="addlocation-container"
      >
        <Col lg={18} md={18} sm={24} xs={24}>
          <div className="site-card-border-less-wrapper">
            <Form onSubmit={this.handleSubmit}>
              <Card title="Add Location" style={{ borderRadius: "10px" }}>
                <Row gutter={10}>
                  <Col lg={24} md={24} sm={24} sx={24}>
                    <Form.Item
                      className="Formitem"
                      label={
                        <span style={{ color: "#7B8190", fontSize: "14px" }}>
                          Location Name
                        </span>
                      }
                    >
                      {getFieldDecorator("locationName", {
                        rules: [
                          {
                            required: true,
                            message: "Please input Location Name!",
                          },
                          noWhitespaceRule,
                        ],
                      })(<Input />)}
                    </Form.Item>
                  </Col>
                  <Col lg={24} md={24} sm={24} sx={24}>
                    <Form.Item
                      label={
                        <span style={{ color: "#7B8190", fontSize: "14px" }}>
                          Address
                        </span>
                      }
                    >
                      {getFieldDecorator("address", {
                        rules: [
                          {
                            required: true,
                            message: "Please input your address!",
                          },
                        ],
                      })(
                        <LocationAutocomplete
                          getAddress={(address, latLng) =>
                            this.getAddress(address, latLng)
                          }
                          editMode={this.state.editMode}
                          address={this.state.previousAddress}
                          setAddress={(address) => {
                            this.setState({ previousAddress: address });
                          }}
                        />
                        // <Input label='Address' id='address'  onChange={ e => this.handleOnChange(e) } />
                      )}
                    </Form.Item>
                  </Col>
                  {/* <Col lg={24} md={24} sm={24} sx={24}>
                                        <Form.Item className="Formitem"
                                            label={<span style={{ color: '#7B8190', fontSize: '14px' }}>Address</span>}>
                                            {getFieldDecorator('address', {
                                                rules: [{ required: true, message: 'Please input Location Address!' }],
                                            })(<Input />)}
                                        </Form.Item>
                                    </Col> */}
                  {/* <Col lg={24} md={24} sm={24} sx={24}>
                                        <Form.Item className="Formitem"
                                            label={<span style={{ color: '#7B8190', fontSize: '14px' }}>City</span>}>
                                            {getFieldDecorator('city', {
                                                rules: [{ required: true, message: 'Please input Location City!' }],
                                            })(<Input />)}
                                        </Form.Item>
                                    </Col> */}
                  {/* <Col lg={12} md={12} sm={24} sx={24}>
                                        <Form.Item className="Formitem"
                                            label={<span style={{ color: '#7B8190', fontSize: '14px' }}>State</span>} >
                                            {getFieldDecorator('state', {
                                                rules: [{ required: true, message: 'Please input Location State!' }],
                                            })(<Input />)}
                                        </Form.Item>
                                    </Col>
                                    <Col lg={12} md={12} sm={24} sx={24}>
                                        <Form.Item className="Formitem"
                                            label={<span style={{ color: '#7B8190', fontSize: '14px' }}>Zip</span>}>
                                            {getFieldDecorator('zip', {
                                                rules: [{ required: true, message: 'Please input Location Zip!' }],
                                            })(<Input />)}
                                        </Form.Item>
                                    </Col> */}
                  <Col lg={24} md={24} sm={24} xs={24}>
                    <Form.Item
                      className="Formitem"
                      label={<span className="label">Loading Times</span>}
                      required={true}
                    />
                  </Col>
                  <Col lg={24} md={24} sm={24} xs={24}>
                    <Row gutter={10}>
                      <Col lg={12} md={12} sm={24} xs={24}>
                        <Form.Item>
                          {getFieldDecorator("startTime", {
                            rules: [
                              {
                                required: true,
                                message:
                                  "Please input requested delivery start time",
                              },
                            ],
                          })(
                            <TimePicker
                              placeholder="Start Time"
                              format={format}
                              // open={this.state.startOpen}
                              use12Hours={true}
                              onOpenChange={(startOpen) =>
                                this.setState({ startOpen })
                              }
                              onChange={(value) =>
                                this.setStartValue(value, "startTime")
                              }
                              defaultOpenValue={moment("00:00", "hh:mm A")}
                              minuteStep={15}
                              // disabledHours={this.getStartDisabledHours}
                              // disabledMinutes={this.getStartDisabledMinutes}
                              // addon={() => (
                              //   <Button size="small" type="primary" onClick={() => this.setState({ startOpen: false })}>
                              //     Ok
                              //   </Button>
                              // )}
                            />
                          )}
                        </Form.Item>
                      </Col>
                      <Col lg={12} md={12} sm={24} xs={24}>
                        <Form.Item>
                          {getFieldDecorator("endTime", {
                            rules: [
                              {
                                required: true,
                                message:
                                  "Please input requested delivery end time",
                              },
                            ],
                          })(
                            <TimePicker
                              placeholder="End Time"
                              format={format}
                              use12Hours={true}
                              // onOpenChange={() => this.setState({ endOpen: true })}
                              // onSelect={(value) => this.setEndValue(value,index,'_deliveryEndTime')}
                              onOpenChange={(value) =>
                                this.setEndValue(value, "endTime")
                              }
                              defaultOpenValue={moment("00:00", "hh:mm A")}
                              minuteStep={15}
                              // disabledHours={this.getEndDisabledHours}
                              // disabledMinutes={this.getEndDisabledMinutes}
                              // addon={() => (
                              //   <Button size="small" type="primary" onClick={() => this.setState({ endOpen: false })}>
                              //     Ok
                              //   </Button>
                              // )}
                            />
                          )}
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                  <Col lg={24} md={24} sm={24} xs={24}>
                    <Form.Item
                      className="Formitem"
                      label={<span className="label">Materials Loaded</span>}
                    >
                      {getFieldDecorator("materialsLoaded", {
                        rules: [
                          {
                            required: true,
                            message: "Please input Materials!",
                          },
                        ],
                      })(
                        <Select
                          mode="multiple"
                          allowClear
                          style={{ width: "100%" }}
                          placeholder="Please select"
                          onChange={(value) =>
                            this.setState({ materialsLoaded: value })
                          }
                          showArrow
                        >
                          <Option value="Brown or Red">Brown or Red</Option>
                          <Option value="Liberty Pink">Liberty Pink</Option>
                          <Option value="White River Rock">
                            White River Rock
                          </Option>
                          <Option value="Red and Black Slate">
                            Red and Black Slate
                          </Option>
                          <Option value="Green and Gray Slate">
                            Green and Gray Slate
                          </Option>
                          <Option value="White Marble">White Marble</Option>
                          <Option value="Berkshire">Berkshire</Option>
                          <Option value="Catskill">Catskill</Option>
                          <Option value="Glacier">Glacier</Option>
                          <Option value="Ice Blue">Ice Blue</Option>
                          <Option value="Lakeside WSL">Lakeside WSL</Option>
                          <Option value="Lakeside Double W">
                            Lakeside Double W
                          </Option>
                          <Option value="Crushed Color">Crushed Color</Option>
                          <Option value="Purple">Purple</Option>
                          <Option value="Cape Cod">Cape Cod</Option>
                          <Option value="Bayside Skimmers">
                            Bayside Skimmers
                          </Option>
                          <Option value="New England River Rock">
                            New England River Rock
                          </Option>
                          <Option value="Canadian Pink">Canadian Pink</Option>
                          <Option value="Winchester River Rock">
                            Winchester River Rock
                          </Option>
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                  <Col lg={24} md={24} sm={24} xs={24}>
                    <Form.Item
                      className="Formitem"
                      label={<span className="label">Load Types</span>}
                    >
                      {getFieldDecorator("measurementType", {
                        rules: [
                          {
                            required: true,
                            message: "Please input Load Types!",
                          },
                        ],
                      })(
                        <Select
                          mode="multiple"
                          allowClear
                          style={{ width: "100%" }}
                          placeholder="Select measurement"
                          onChange={(value) =>
                            this.setState({ measurementType: value })
                          }
                          showArrow
                        >
                          {/* <Option value='ton'>Ton</Option> */}
                          <Option value="Pallet">Pallet</Option>
                          {/* <Option value='yard'>Yard</Option> */}
                          <Option value="Truckload">Truckload</Option>
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                  <Col lg={24} md={24} sm={24} xs={24}>
                    <Form.Item
                      className="Formitem"
                      label={<span className="label">Loading Codes</span>}
                    >
                      {getFieldDecorator("loadingCodes", {
                        rules: [
                          {
                            required: false,
                            message: "Please input Loading Codes!",
                          },
                        ],
                      })(
                        <Select
                          mode="multiple"
                          allowClear
                          style={{ width: "100%" }}
                          placeholder="Select measurement"
                          onChange={(value) =>
                            this.setState({ loadingCodes: value })
                          }
                          showArrow
                        >
                          <Option value='3/8" white stone'>
                            3/8" white stone
                          </Option>
                          <Option value='1/2" white stone'>
                            1/2" white stone
                          </Option>
                          <Option value='3/4" white stone'>
                            3/4" white stone
                          </Option>
                          <Option value='1-1/2" white stone'>
                            1-1/2" white stone
                          </Option>
                          <Option value='3/8"'>3/8"</Option>
                          <Option value='3/4"'>3/4"</Option>
                          <Option value='1-1/4"'>1-1/4"</Option>
                          <Option value="pea gravel">pea gravel</Option>
                          <Option value='3/4" coarse'>3/4" coarse</Option>
                          <Option value='2" roofing gravel'>
                            2" roofing gravel
                          </Option>
                          <Option value='2-4" gravel'>2-4" gravel</Option>
                          <Option value='3/4" red slate'>3/4" red slate</Option>
                          <Option value='3/4" black slate'>
                            3/4" black slate
                          </Option>
                          <Option value='1-1/4" red slate'>
                            1-1/4" red slate
                          </Option>
                          <Option value='1-1/4" black slate'>
                            1-1/4" black slate
                          </Option>
                          <Option value='3/4" green slate'>
                            3/4" green slate
                          </Option>
                          <Option value='3/4" gray slate'>
                            3/4" gray slate
                          </Option>
                          <Option value='1-1/4" green slate'>
                            1-1/4" green slate
                          </Option>
                          <Option value='1-1/4" gray slate'>
                            1-1/4" gray slate
                          </Option>
                          <Option value='3/8" native stone'>
                            3/8" native stone
                          </Option>
                          <Option value='3/4" native stone'>
                            3/4" native stone
                          </Option>
                          <Option value='1-1/4" native stone'>
                            1-1/4" native stone
                          </Option>
                          <Option value='2-1/2" native stone'>
                            2-1/2" native stone
                          </Option>
                          <Option value='3/4" washed gravel'>
                            3/4" washed gravel
                          </Option>
                          <Option value='1-1/2" washed gravel'>
                            1-1/2" washed gravel
                          </Option>
                          <Option value='2-5" washed gravel'>
                            2-5" washed gravel
                          </Option>
                          <Option value='1/4" round gravel'>
                            1/4" round gravel
                          </Option>
                          <Option value='3/8" round gravel'>
                            3/8" round gravel
                          </Option>
                          <Option value='1/2" round gravel'>
                            1/2" round gravel
                          </Option>
                          <Option value='3/4" round gravel'>
                            3/4" round gravel
                          </Option>
                          <Option value='1-2" round gravel'>
                            1-2" round gravel
                          </Option>
                          <Option value='2-4" round gravel'>
                            2-4" round gravel
                          </Option>
                          <Option value='3-6" round gravel'>
                            3-6" round gravel
                          </Option>
                          <Option value="cobbles">cobbles</Option>
                          <Option value='3/8" blue stone'>
                            3/8" blue stone
                          </Option>
                          <Option value='3/4" blue stone'>
                            3/4" blue stone
                          </Option>
                          <Option value='1-1/2" blue stone'>
                            1-1/2" blue stone
                          </Option>
                          <Option value="#1 round stone">#1 round stone</Option>
                          <Option value="#2 round stone">#2 round stone</Option>
                          <Option value="#3 round stone">#3 round stone</Option>
                          <Option value="#4 round stone">#4 round stone</Option>
                          <Option value="#2s">#2s</Option>
                          <Option value="#3s">#3s</Option>
                          <Option value="#3s and #4s">#3s and #4s</Option>
                          <Option value="double washed cobbles">
                            double washed cobbles
                          </Option>
                          <Option value="#2 crushed stone">
                            #2 crushed stone
                          </Option>
                          <Option value="#3 crushed stone">
                            #3 crushed stone
                          </Option>
                          <Option value='3/8" purple stone'>
                            3/8" purple stone
                          </Option>
                          <Option value='3/4" purple stone'>
                            3/4" purple stone
                          </Option>
                          <Option value='1-1/4" purple stone'>
                            1-1/4" purple stone
                          </Option>
                          <Option value='3/8" natural round stone'>
                            3/8" natural round stone
                          </Option>
                          <Option value='3/4" natural round stone'>
                            3/4" natural round stone
                          </Option>
                          <Option value='1-1/2" natural round stone'>
                            1-1/2" natural round stone
                          </Option>
                          <Option value='2" natural round stone'>
                            2" natural round stone
                          </Option>
                          <Option value='6-12" natural round stone'>
                            6-12" natural round stone
                          </Option>
                          <Option value='12-24" natural round stone'>
                            12-24" natural round stone
                          </Option>
                          <Option value="#78s">#78s</Option>
                          <Option value="#57s">#57s</Option>
                          <Option value="#3s">#3s</Option>
                          <Option value="#2-3s">#2-3s</Option>
                          <Option value="#3-4s">#3-4s</Option>
                          <Option value="pink cobbles">pink cobbles</Option>
                          <Option value="#57s round gravel">
                            #57s round gravel
                          </Option>
                          <Option value="Large river rock">
                            Large river rock
                          </Option>
                          <Option value="xlarge river rock">
                            xlarge river rock
                          </Option>
                          <Option value="#2 large scalpings">
                            #2 large scalpings
                          </Option>
                          <Option value="oversized">oversized</Option>
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                  <Col
                    lg={24}
                    md={24}
                    sm={24}
                    xs={24}
                    style={{ marginTop: "4%" }}
                  >
                    <p style={{ fontWeight: "bold" }}>Contact Info</p>
                  </Col>
                  <Col lg={12} md={12} sm={24} xs={24}>
                    <Form.Item
                      className="Formitem"
                      label={<span className="label">First Name</span>}
                    >
                      {getFieldDecorator("firstName", {
                        rules: [
                          {
                            required: true,
                            message: "Please input contact First Name!",
                          },
                          noWhitespaceRule,
                        ],
                      })(<Input placeholder="First name" />)}
                    </Form.Item>
                  </Col>
                  <Col lg={12} md={12} sm={24} xs={24}>
                    <Form.Item
                      className="Formitem"
                      label={<span className="label">Last Name</span>}
                    >
                      {getFieldDecorator("lastName", {
                        rules: [
                          {
                            required: true,
                            message: "Please input contact Last Name!",
                          },
                          noWhitespaceRule,
                        ],
                      })(<Input placeholder="Last name" />)}
                    </Form.Item>
                  </Col>
                  <Col lg={12} md={12} sm={24} sx={24}>
                    <Form.Item
                      className="Formitem"
                      label={
                        <span style={{ color: "#7B8190", fontSize: "14px" }}>
                          Email
                        </span>
                      }
                    >
                      {getFieldDecorator("email", {
                        rules: [
                          {
                            required: false,
                            type: "email",
                            message: "Please input Email!",
                          },
                          noWhitespaceRule,
                        ],
                      })(<Input />)}
                    </Form.Item>
                  </Col>
                  <Col lg={12} md={12} sm={24} sx={24}>
                    <Form.Item
                      className="Formitem"
                      label={
                        <span style={{ color: "#7B8190", fontSize: "14px" }}>
                          Phone
                        </span>
                      }
                    >
                      {getFieldDecorator("phone", {
                        rules: [
                          {
                            required: true,
                            message: "Please input contact Phone Number!",
                          },
                          noWhitespaceRule,
                          notValidPhoneNumberRule,
                        ],
                      })(<Input />)}
                    </Form.Item>
                  </Col>
                  {/* <Col lg={12} md={12} sm={24} xs={24} >
                                        <Form.Item label={<span style={{ color: '#7B8190', fontSize: '14px' }}>Upload location map</span>}
                                        >
                                            {getFieldDecorator('map', {
                                                rules: [{ required: this.state.editMode ? false : true, message: 'Please upload Map!' }],
                                            })(
                                                <div className="addlocation-uploadbtn">
                                                    <Upload {...props} setFieldsValue={this.state.sizeUploadImg}>
                                                        <Button>
                                                            <Icon type="upload" />Upload
                                                        </Button>
                                                    </Upload>
                                                </div>
                                            )}
                                        </Form.Item>

                                    </Col> */}
                </Row>
              </Card>
              <Row>
                <Form.Item style={{ marginTop: "5%" }}>
                  <Button
                    type="primary"
                    style={{
                      backgroundColor: "#25559517",
                      color: "#255595",
                      marginRight: "30px",
                      padding: "0 20px 0 20px",
                      border: "none",
                    }}
                  >
                    <Link to="/app/settings">Cancel</Link>
                  </Button>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={this.state.loading}
                    onClick={this.handleSubmit}
                    style={{
                      float: "right",
                      backgroundColor: "#255595",
                      color: "white",
                      padding: "0 20px 0 20px",
                    }}
                  >
                    Save
                  </Button>
                </Form.Item>
              </Row>
            </Form>
          </div>
        </Col>
      </div>
    );
  }
}
export default Form.create({ name: "addlocation" })(withRouter(AddLocation));
